/**
 * Hubspot
 *
 * @author Rasmus Seindal <rseindal@vertic.com>
 */

import ServerView from '../../framework/server-side-view';

const View = ServerView.extend({
	el: '.js-hubspot-modal-btn',

	events: {
		click: 'onClickOpenModal',
	},

	openModal(type, hubSpot) {
		App.modal.create({
			type,
			model: {
				hubSpot,
			},
		});
	},

	onClickOpenModal() {
		if (this.el.classList.contains('js-hubspot-desktop-only') && window.innerWidth <= 768) return;
		const hubSpotData = JSON.parse(this.el.dataset.hubspotdata);

		this.openModal('generic-signup-modal', hubSpotData);
	},
});

export default View;
